import React, {Component} from 'react'
import {Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import numeral from 'numeral'
import IgniteDataTable from '../../../common/datatable'
import ConfirmPopup from '../../../common/confirm-popup'
import store, {history} from '../../../../store'
import {deleteFile} from '../../../../actions/files';

class DownloadsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  render() {
    const columns = [
      {prop: 'name', title: 'Filename'},
      {
        prop:  'size',
        title: 'Size',
        width: '150',
        format(cell, row) {
          return numeral(cell).format('0.00 b')
        }
      },
      {
        prop:  'permalink',
        title: 'Permalink',
        width: '150',
        format(cell, row) {return <Button bsStyle="link" href={cell} target="_blank">Permalink</Button>},
      },
    ];

    const actions = [
      {
        label:    'Edit',
        callback: (row) => {
          history.push(`/admin/downloads/${row.id}`);
        }
      },
      {
        label:    'Delete',
        color:    'grey',
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    const handleDelete = (result) => {
      const id = this.state.delete.id;
      this.setState({delete: {show: false}});
      if (result) {
        store.dispatch(deleteFile(id));
      }
    };

    return (
      <div>
        <IgniteDataTable data={this.props.files}
                         columns={columns}
                         actions={actions}
                         actionWidth="280"/>

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE FILE?"
                        onClose={handleDelete}>
            <p>Are you sure you want to delete the selected file?</p>
          </ConfirmPopup>
        }

      </div>
    )
  }
}

export default DownloadsList


// WEBPACK FOOTER //
// ./src/components/admin/downloads/list/downloads-list.jsx